// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/css/head.css
// module id = 1995
// module chunks = 2